<template>
  <div id="order-summary" class="container">
    <p class="title mb-4" style="font-size: 24px; font-weight: bold">{{ $t('components.order-summary.title') + ":&nbsp;" + order?.coverModel }}</p>
    <div v-if="isTypeCovers || isTypeBrace">
      <!-- Product data -->
      <div class="row" style="align-items: left;">
        <div class="col-12 col-lg-4" >
          <div v-if="product?.productTypeAttribute?.productTypeAttributeName">
            <label class="form-label text-secondary" for="body-side-readonly">{{ $t('views.customize.workflow.form.productTypeAttribute') + ":&nbsp;" }}</label>
            <label class="form-label">{{ $t(`enum.productTypeAttributes.${product?.productTypeAttribute?.productTypeAttributeName}`) }}</label>
          </div>
          <div v-if="(!isSCover || isMCover) && isTypeCovers">
            <label class="form-label text-secondary" for="body-side-readonly">{{ $t('views.customize.workflow.form.bodySide') + ":&nbsp;" }}</label>
            <label class="form-label">{{ $t(`enum.bodySide.${order?.bodySide}`) }}</label>
          </div>
          <div v-if="!isSCover && isTypeCovers">
            <label class="form-label text-secondary">{{ $t('views.customize.workflow.form.kneeJoint') + ":&nbsp;" }}</label>
            <label class="form-label">{{ order?.kneeJoint || '-' }}</label>
          </div>


          <p class="fs-4 mt-4">{{ $t('components.order-summary.designOptions') }}</p>
          <div v-if="(colorList.length > 1 && isFlex) || embossingColorList.length > 0" class="row">
            <div class="col-6">
              <div v-if="colorList.length > 0 && isXCover">
                <label class="form-label text-secondary">{{ $t('components.order-summary.baseColor') }}</label>
                <div class="d-flex flex-wrap flex-dir-row gap-2">
                  <el-tooltip v-for="color in selectedColors" :key="$t(`views.colors.${color.name}`)" placement="top" :content="$t(`views.colors.${color.name}`)">
                    <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="colorList.length > 1 && isFlex && !isXCoverFlex">
                <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.baseColor') }}</label>
                <div class="d-flex flex-wrap flex-dir-row gap-2">
                  <el-tooltip v-for="color in selectedColors.slice(0, -1)" :key="$t(`views.colors.${color.name}`)" placement="top" :content="$t(`views.colors.${color.name}`)">
                    <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="colorList.length > 1 && isFlex && !isXCoverFlex">
                <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.zipColor') }}</label>
                <div class="d-flex flex-wrap flex-dir-row gap-2">
                  <el-tooltip v-if="selectedColors[selectedColors.length - 1]" :key="$t(`views.colors.${selectedColors[selectedColors.length - 1].name}`)" placement="top" :content="$t(`views.colors.${selectedColors[selectedColors.length - 1].name}`)">
                    <div class="rounded-circle" :style="'background: rgb(' + selectedColors[selectedColors.length - 1].red + ',' + selectedColors[selectedColors.length - 1].green + ',' + selectedColors[selectedColors.length - 1].blue + ')'"></div>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="embossingColorList.length > 0">
                <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.embossingColor') }}</label>
                <div class="d-flex flex-wrap flex-dir-row gap-2">
                  <el-tooltip v-for="color in selectedEngravingColors" :key="$t(`views.colors.${color.name}`)" placement="top" :content="$t(`views.colors.${color.name}`)">
                    <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div v-if="selectedEngravings.length > 0 && hasNonBlankEngraving">
                <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.embossing') }}</label>
                <!-- <label class="col-sm-6 form-label">{{ embossingList.join(', ') }}</label> -->
                <div  class="d-flex flex-wrap flex-dir-row gap-2">
                  <div v-for="design in selectedEngravings" :key="design.fileId!">
                    <el-tooltip v-if="!design.name.includes('blank')" :key="design.fileId" placement="right" :content="$t(`views.designs.${design.name}`)">
                      <img :src="design.content" :alt="design.name" class="design-thumbnail" />
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="(colorList.length > 0 && isXCover) || isSCover || isMCover || isBrace">
              <label class="form-label text-secondary">{{ $t('components.order-summary.baseColor') }}</label>
              <div class="d-flex flex-wrap flex-dir-row gap-2">
                <el-tooltip v-for="color in selectedColors" :key="$t(`views.colors.${color.name}`)" placement="top" :content="$t(`views.colors.${color.name}`)">
                  <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
                </el-tooltip>
              </div>
            </div>
            <div v-if="colorList.length > 1 && isFlex">
              <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.baseColor') }}</label>
              <div class="d-flex flex-wrap flex-dir-row gap-2">
                <el-tooltip v-for="color in selectedColors.slice(0, -1)" :key="$t(`views.colors.${color.name}`)" placement="top" :content="$t(`views.colors.${color.name}`)">
                  <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
                </el-tooltip>
              </div>
            </div>
            <div v-if="colorList.length > 1 && isFlex">
              <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.zipColor') }}</label>
              <div class="d-flex flex-wrap flex-dir-row gap-2">
                <el-tooltip v-if="selectedColors[selectedColors.length - 1]" :key="$t(`views.colors.${selectedColors[selectedColors.length - 1].name}`)" placement="top" :content="$t(`views.colors.${selectedColors[selectedColors.length - 1].name}`)">
                  <div class="rounded-circle" :style="'background: rgb(' + selectedColors[selectedColors.length - 1].red + ',' + selectedColors[selectedColors.length - 1].green + ',' + selectedColors[selectedColors.length - 1].blue + ')'"></div>
                </el-tooltip>
              </div>
            </div>
            <div v-if="embossingColorList.length > 0">
              <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.embossingColor') }}</label>
              <div class="d-flex flex-wrap flex-dir-row gap-2">
                <el-tooltip v-for="color in selectedEngravingColors" :key="$t(`views.colors.${color.name}`)" placement="top" :content="$t(`views.colors.${color.name}`)">
                  <div class="rounded-circle" :style="'background: rgb(' + color.red + ',' + color.green + ',' + color.blue + ')'"></div>
                </el-tooltip>
              </div>
            </div>
            <div v-if="selectedEngravings.length > 0 && hasNonBlankEngraving">
              <label class="form-label text-secondary mt-2">{{ $t('components.order-summary.embossing') }}</label>
              <!-- <label class="col-sm-6 form-label">{{ embossingList.join(', ') }}</label> -->
              <div class="d-flex flex-wrap flex-dir-row gap-2">
                <div v-for="design in selectedEngravings" :key="design.fileId!">
                  <el-tooltip v-if="!design.name.includes('blank')" :key="design.fileId" placement="right" :content="$t(`views.designs.${design.name}`)">
                    <img :src="design.content" :alt="design.name" class="design-thumbnail" />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 d-flex justify-content-center">
          <div class="wrapper">
            <div class="crop">
              <img v-if="screenShots.length > 0" :src="screenShots[0]" class="screenshot" alt="Screenshot" />
            </div>
            <div v-if="!isTypeBrace">
              <div class="callout" style="top: 10%; left: 40%">
                <div class="dot"></div>
                <div class="line"></div>
                <div class="label">{{ $t('components.order-form.scope-top') + ': ' + order?.depth }}</div>
              </div>
              <div class="callout" style="top: 40%; left: 42%">
                <div class="dot"></div>
                <div class="line"></div>
                <div class="label">{{ $t('components.order-form.height') + ': ' + order?.heightWithoutDeduction }}</div>
              </div>
              <div class="callout" style="top: 74%; left: 38%">
                <div class="dot"></div>
                <div class="line"></div>
                <div class="label">{{ $t('components.order-form.scope-bottom') + ': ' + order?.calfCircumferenceWithoutDeduction }}</div>
              </div>
            </div>
            <div v-if="isTypeBrace">
              <div class="callout" style="top: 40%; left: 42%">
                <div class="dot"></div>
                <div class="line"></div>
                <div class="label">{{ $t('components.order-form.strength') + ': ' + order?.heightWithoutDeduction }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row" style="align-items: left;">
        <div class="col-12 col-lg-4" style="max-height: 20rem;">
          <!-- Parameter -->
          <!-- <product-parameter-cover v-if="product.type.name.toLowerCase() == 'covers'" :order="order" :product="product" :readonly="true" /> -->
          <!-- TODOS: ADJUST IF PROPS -->
          <product-parameter-template
            v-if="isPhase1Product(product.name)"
            :order="order"
            :product="product"
            :readonly="true"
          />

          <!-- TODOS: ADJUST IF PROPS -->
          <!-- v-if="isTypeOrthesen" -->
          <product-parameter-orthesis
            v-if="isTypeOrthesen && !isPhase1Product(product.name)"
            :order="order"
            :product="product"
            :readonly="true"
          />
          <product-parameter-cuboid
            v-if="isTypeMobel || isTypeAutos || isTypeGebaude"
            :order="order"
            :readonly="true"
          />
          <product-parameter-balcony v-if="isTypeBalkone" :order="order" :readonly="true" />
          <product-parameter-fence v-if="isTypeZaune" :order="order" :readonly="true" />
          <product-parameter-linear-light
            v-if="isTypeLineareBeleuchtung"
            :order="order"
            :is-hanging-light="product.name.toLowerCase() === LinearLightNameType.hanging.toLowerCase()"
            :is-surface-mounted-light="product.name.toLowerCase() === LinearLightNameType.surfaceMounted.toLowerCase()"
            :readonly="true"
          />
          <product-parameter-bathtub v-if="isTypeDuschenBader" :order="order" :readonly="true" />
        </div>
        <div class="col-12 col-lg-8 d-flex justify-content-center" style="max-height: 20rem;">
          <div class="wrapper">
            <div class="crop" style="transform-origin: 30% 90%">
              <img v-if="screenShots.length > 0" :src="screenShots[0]" class="screenshot" alt="Screenshot" />
            </div>
          </div>
        </div>
      </div>

      <!-- Part list -->
      <div v-if="isSupplierOrReserller() && !isCover">
        <h3 class="mt-3">{{ $t('components.order-summary.parts') }}</h3>
        <div v-for="part in Object.entries(meshGroupedPartItems)" :key="part[0]" class="row1">
          <label class="col form-label">{{ $t('components.part-selection.' + product.type.name.toLowerCase() + '.' + part[0]) ? part[1].reduce((sum, current) => sum + current.cnt, 0) + 'x ' + $t('components.part-selection.' + product.type.name.toLowerCase() + '.' + part[0]) : part[1].length + 'x ' + part[0] }}</label>
          <div v-for="item in part[1]" :key="item.meshTreeDataItem.name">
            <label v-if="item.meshTreeDataItem.size?.width" class="col form-label text-secondary mb-1">{{ item.cnt + 'x ' + Math.ceil(item.meshTreeDataItem.size?.width) + ' mm' }}</label>
            <label v-if="item.meshTreeDataItem.size?.height" class="col form-label text-secondary mb-1">{{ Math.ceil(item.meshTreeDataItem.size?.height) + ' mm' }}</label>
            <label v-if="item.meshTreeDataItem.size?.depth" class="col form-label text-secondary mb-1">{{ Math.ceil(item.meshTreeDataItem.size?.depth) + ' mm' }}</label>
          </div>
        </div>
      </div>

      <!-- Delivery -->
      <!-- <div v-if="product.type.name.toLowerCase() == 'balkone'" class="row border-0">
        <div class="mb-2">
          <div class="row1">
            <label class="col form-label text-secondary">{{ $t('components.order-summary.balcony.price-information') }}</label>
          </div>
        </div>
      </div>
      <div v-else class="row border-0">
        <div class="col mb-2">
          <div class="row1">
            <label class="col form-label text-secondary">{{ $t('components.order-summary.shippingCosts') }}: {{ $t('components.order-summary.shippingCostsInfo') }}</label>
          </div>
        </div>
      </div> -->

      <!-- Amortisation -->
      <p v-if="isTypeBalcone" class="fs-4 mt-4">{{ $t('components.order-summary.amortisation') }}</p>
      <div v-if="isTypeBalcone" v-loading="calculatingAmortisation" class="row border-0">
        <div class="mb-2">
          <div class="row1">
            <label class="col-sm-6 form-label text-secondary">{{ $t('components.product-parameter.balcony.orientation-type') }}</label>
            <label class="col-sm-6 form-label">{{ $t(`enum.orientationType.${order?.orientationType}`) }}</label>
          </div>
          <div class="row1">
            <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-summary.savings-per-year') }}</label>
            <label class="col-sm-6 form-label">{{ savingsPerYear.toFixed(2) }} €</label>
          </div>
          <div class="row1">
            <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-summary.amortisation') }}</label>
            <label class="col-sm-6 form-label">{{ amortisation <= 30 ? amortisation.toFixed(0) : '+30' }} {{ $t('components.order-summary.years') }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit, Prop} from 'vue-facing-decorator';

import PreviewRendererImg from '@/components/features/previewRenderer/PreviewRendererImg.vue';
import { OrderRequestData } from '@/services/api/orderService';
import PreviewRenderer from '@/components/three/scenes/PreviewRenderer.vue';
import { MeshTreeData, MeshTreeDataGroupItem, MeshTreeDataItem } from '@/types/ui/MeshTreeData';
import { Product } from '@/types/api/Model/Product';
import Auth from '@/services/api/auth';
import { Role } from '@/types/enum/user';
import * as modelService from '@/services/api/modelService';
import { OrientationType, LinearLightNameType } from '@/types/enum/order';
import { getI18nLocale } from '@/i18n';
import de from '@/locales/de.json';
import en from '@/locales/en.json';
import ProductParameterCover from '../productParameters/ProductParameterCover.vue';
import ProductParameterTemplate from '../productParameters/ProductParameterTemplate.vue';
import ProductParameterOrthesis from '../productParameters/ProductParameterOrthesis.vue';
import ProductParameterBrace from '@/components/productParameters/ProductParameterBrace.vue';
import ProductParameterCuboid from '../productParameters/ProductParameterCuboid.vue';
import ProductParameterBalcony from '../productParameters/ProductParameterBalcony.vue';
import ProductParameterFence from '../productParameters/ProductParameterFence.vue';
import ProductParameterLinearLight from '../productParameters/ProductParameterLinearLight.vue';
import ProductParameterBathtub from '../productParameters/ProductParameterBathtub.vue';
import { useUserStore } from '@/stores/userStore';
import ButtonCardConfig from '../layout/ButtonCardConfig.vue';
import { RGB2 } from '@/types/api/Utility/RGB2';
import { File as UtilityFile } from '@/types/api/Utility/File';

@Component({
  components: {
    PreviewRendererImg,
    PreviewRenderer,
    ProductParameterBalcony,
    ProductParameterCover,
    ProductParameterCuboid,
    ProductParameterFence,
    ProductParameterTemplate,
    ProductParameterOrthesis,
    ProductParameterBrace,
    ProductParameterLinearLight,
    ProductParameterBathtub,
    ButtonCardConfig
  },
})
export default class OrderSummary extends Vue {
  @Prop() order!: OrderRequestData;
  @Prop({ default: 0 }) price!: number;
  @Prop() meshTreeData!: MeshTreeData;
  @Prop({ default: [] }) treeData!: MeshTreeDataItem[];
  @Prop() selectedColors!: RGB2[];
  @Prop() selectedEngravings!: UtilityFile[];
  @Prop() selectedTextures!: UtilityFile[];
  @Prop() selectedEngravingColors!: RGB2[];
  @Prop() selectedTextureColors!: RGB2[];
  @Prop() product!: Product;
  @Prop() screenShots!: string[];

  locale = getI18nLocale() === 'en' ? en : de;
  userStore = useUserStore();

  RegionalEnergyYield = 950;
  EuroPerKWh = 0.4;

  colorList: string[] = [];
  embossingList: string[] = [];
  embossingColorList: string[] = [];
  authentication = Auth.getInstance();
  Role = Role;
  savingsPerYear = 0.0;
  amortisation = 0;
  calculatingAmortisation = false;

  LinearLightNameType = LinearLightNameType;

  meshGroupedPartItems: { [key: string]: MeshTreeDataGroupItem[] } = {};

  mounted(): void {
    this.colorList = [...new Set(this.selectedColors.map((c) => this.$t(`views.colors.${c.name}`)))];
    this.embossingList = [
      ...new Set(this.selectedEngravings.map((e) => this.$t(`views.designs.${e.name}`)) ?? []),
      ...new Set(this.selectedTextures.map((w) => this.$t(`views.designs.${w.name}`)) ?? []),
          ]
    this.embossingColorList = [
      ...new Set(this.selectedEngravingColors.map((ec) => this.$t(`views.colors.${ec.name}`))),
      ...new Set(this.selectedTextureColors.map((wc) => this.$t(`views.colors.${wc.name}`))),
          ]

    this.meshTreeData.getGroupedPartItems(false).then((list) => {
      this.meshGroupedPartItems = list;
    });
    this.calculateAmortisation();
  }

  @Emit('update:calculatingAmortisation')
  private toggleCalculateAmortisation(status: boolean): boolean {
    this.calculatingAmortisation = status;
    return this.calculatingAmortisation; // Emit calculatingAmortisation value to parent
  }

  isSupplierOrReserller(): boolean {
    return this.userStore.isAuthenticated && (this.userStore.roles.includes(Role.Reseller) || this.userStore.roles.includes(Role.Supplier));
  }

  isUser(): boolean {
    return this.userStore.isAuthenticated && this.userStore.roles.includes(Role.User) && !this.isSupplierOrReserller();
  }


  async calculateAmortisation() {
    this.toggleCalculateAmortisation(true);
    let wp = 0.0;
    for (const treeData of this.meshTreeData.treeData.filter((m) => m.componentId != null)) {
      const power = await modelService.getPower(treeData.componentId!);
      if (power) {
        wp += power.value;
      }
    }
    const kWp = wp / 1000;

    let personalEnergyYield = this.RegionalEnergyYield;
    switch (this.order.orientationType) {
      case OrientationType.south: {
        personalEnergyYield *= 1; // 100 %
        break;
      }
      case OrientationType.eastOrWest: {
        personalEnergyYield *= 0.8; // 80%
        break;
      }
    }

    const kWh = kWp * personalEnergyYield;

    this.savingsPerYear = kWh * this.EuroPerKWh;
    this.amortisation = this.price / this.savingsPerYear;
    this.toggleCalculateAmortisation(false);
  }

  isPhase1Product(productName:string){
    return productName.replace(/\s/g, '').toLowerCase().includes('phase1')
  }

  
  get hasNonBlankEngraving(){
   return !this.selectedEngravings.every(e => e.name.includes('blank'));
  }
  get isTypeBalcone(){
   return this.product.type.name.toLowerCase() == 'balkone' 
  }
  get isTypeCovers(){
    return this.product.type.name.toLowerCase() == 'covers'
  }
  get isTypeOrthesen(){
    return this.product.type.name.toLowerCase() == 'orthesen'
  }
  get isTypeBrace() {
    return this.product.type.name.toLowerCase() == 'brace';
  }
  get isTypeMobel(){
    return this.product.type.name.toLowerCase() == 'möbel'
  }
  get isTypeAutos(){
    return this.product.type.name.toLowerCase() == 'möbel'
  }
  get isTypeGebaude(){
    return this.product.type.name.toLowerCase() == 'gebäude'
  }
  get isTypeBalkone(){
    return this.product.type.name.toLowerCase() == 'balkone'
  }
  get isTypeZaune(){
    return this.product.type.name.toLowerCase() == 'zäune'
  }
  get isTypeLineareBeleuchtung(){
    return this.product.type.name.toLowerCase() == 'lineare beleuchtung'
  }
  get isTypeDuschenBader(){
    return this.product.type.name.toLowerCase() == 'duschen und bäder'
  }

  get isFlex(){
    return this.product.name.toLowerCase().includes('flex') && !this.product.name.toLowerCase().includes('x-cover')
  }
  get isXCover(){
    return this.product.name.toLowerCase().includes('x-cover') || this.product.name.toLowerCase().includes('prothesenschaft')
  }
  get isCover(){
    return this.product?.name.toLowerCase().includes('cover')
  }
  get isSCover(){
    return this.product?.name.toLowerCase().includes('s-cover')
  }

  get isMCover(){
    return this.product?.name.toLowerCase().includes('m-cover')
  }

  get isBrace(){
    return this.product?.name.toLowerCase().includes('korsett')
  }

  get isXCoverFlex() {
    const words = (this.product?.name ?? "").toLowerCase().split(/\W+/)
    return words.includes("x") && words.includes("flex")
  }
}
</script>

<style scoped lang="scss">
#order-summary {
  justify-self: right;
  align-self: end;
  background: #fff;
  margin-bottom: 4rem;
}

.title {
  font-size: 24px;
  font-weight: bold;
}

.h2,
.h3,
.text-secondary {
  color: #0000008d !important;
  text-align: left !important;
}

.row1 {
  border-bottom: 0.1rem solid #6767678d;
}

.form-label {
  font-size: 1rem;
  margin: 0.7rem 0 0.5rem 0;
  text-align: right;
}

.rounded-circle {
  border: 0.2rem solid white;
  box-shadow: 0 0 0 0.1rem #6767678d;
  transition: all 0.1s ease-in-out;
}

.rounded-circle:hover {
  transform: scale(1.03);
  box-shadow: 0 0 0 0.2rem #6767678d;
}

.design-thumbnail {
  height: 6rem !important;
  width: 6rem !important;
  object-fit: cover;
  border-radius: 0.5rem;
  border: 0.1rem solid #6767678d;
  transition: all 0.1s ease-in-out;
}

.design-thumbnail:hover {
  transform: scale(1.03);
  box-shadow: 0 0 0 0.2rem #6767678d;
}

.wrapper {
  position: relative;
  width: 120%;
  max-width: 550px;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.crop {
  position: relative;
  width: 100%;
  height: 100%;
  transform: scale(1.5);
  transform-origin: 75% 60%;
}

.screenshot {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.callout {
  position: absolute;
  display: flex;
  align-items: center;
}

.dot {
  width: 10px;
  height: 10px;
  background: rgb(54, 54, 54);
  border-radius: 50%;
  z-index: 2;
}

.line {
  width: 80px;
  height: 2px;
  background: rgb(54, 54, 54);
  margin-right: 6px;
}

.label {
  margin-right: 8px;
  background: white;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.85rem;
  white-space: nowrap;
  transition: all 0.1s ease-in-out;
}

.label:hover {
  transform: scale(1.03);
}
</style>
